import styled from "styled-components";

export const CMLi = styled.li`
  padding: 5px 1rem;
  list-style-type: none;
  transition: height 1s ease;
  position: relative;
  cursor: pointer;

  &:not(.hide-smicon-link):hover,
  &.active {
    & > a {
      border-bottom: solid 2px ${(props) => props.theme.palette.primary.main};
    }
  }
  .custom-submenu.submenu {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 9px 4px;
    @media (min-width: 2000px) {
          width: 20vh !important;
          padding:2vh !important;
    }
    @media ${(props) => props.theme.breakpoints.lg} {
    box-shadow: none;
    }
  }
  a {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    text-decoration: none;
    text-transform: uppercase;
  }

  svg {
    margin-bottom: -10px;
  }

  &.hide-lg {
    svg {
      display: none;
    }
  }

  &.submenu-container {
    
    &:hover {
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      background-color: white;

      &::before {
        display: block;
      }

      & .submenu {
        display: block;
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      height: 15px;
      background-color: white;
      display: none;
      left: 0;
    }

    // submenu settings
    & .submenu {
      right: 0;
      top: calc(100% + 15px);
      margin: 0;
      padding: 25px 10px;
      width: calc(254px - 60px);
      position: absolute;
      background-color: white;
      border-radius: 14px;
      border-top-right-radius: 0;
      display: none;
      z-index: 999999;
      //border: 1px solid red;

      

      & li {
        padding-bottom: 15px;

        &.dotted-border {
          padding-top: 25px;
          background-position: top;
          @media ${(props) => props.theme.breakpoints.lg} {
            background: none;
          }
        }

        & a {
          display: block;
          padding-bottom: 10px;
          text-transform: capitalize;
        }

        &:hover,
        &.active {
          & a {
            border: unset !important;
            color: ${(props) => props.theme.palette.primary.main};
          }
        }
      }

      @media ${(props) => props.theme.breakpoints.lg} {
        all:unset;
        width: 100%;
        box-shadow: none;
        border-top-right-radius: 14px;
      }

      @media ${(props) => props.theme.breakpoints.md}, ${(props) => props.theme.breakpoints.sm} {
        max-width: 100%;
        padding: 0px;
        box-shadow:none ;
        border-top-right-radius: 14px;
      }     

      @media ${(props) => props.theme.breakpoints.xs} {
        max-width: 90%;
        padding: 0px;
        box-shadow:none ;
        border-top-right-radius: 14px;
      }      
    }
  }

  &.menucontent-container {
    &:hover {
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      background-color: white;

      &::before {
        display: block;
      }

      & .submenu {
        display: block;
        @media (min-width: 2000px) {
          padding:2vh;
          width: 35vh !important;
        }
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      height: 15px;
      background-color: white;
      display: none;
      left: 0;
    }

    // submenu "add funds"
    & .submenu {
      right: 0;
      top: calc(100% + 15px);
      margin: 0;
      padding: 30px;
      width: calc(400px - 60px);
      position: absolute;
      background-color: white;
      border-radius: 14px;
      border-top-right-radius: 0;
      display: none;
      z-index: 999999;
      //border: 1px solid green;

      @media ${(props) => props.theme.breakpoints.lg},
       ${(props) => props.theme.breakpoints.md},
       ${(props) => props.theme.breakpoints.sm} {
        all: unset;
        padding: 0px;
        max-width: 100%;
        border-top-right-radius: 14px;
        margin: 0px;
      }


      @media ${(props) => props.theme.breakpoints.xs} {
        padding: 1em!important;  
        max-width: 90%; 
        border-top-right-radius: 14px;
      }

      & .link {
        @media (min-width: 2000px) {
          font-size: 2vh;
        }
      }

      & .content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        @media (min-width: 2000px) {
        & h3 {
        font-size: 3vh;
        }
        & button {
        font-size: 2.8vh;
        }
        }
      }

      & .content-around {
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;


        & .dotted-border {
          padding-top: 10px;
          background-position: top;
          @media (min-width: 2000px) {
            & h4 {
            font-size: 2vh;
            }
            & span {
            font-size: 2vh;
            }
          }
        }
      }

      & a {
        text-transform: none;
        text-decoration: underline;
        color: #0070E0;
      }

      & a:hover {
        border: unset !important;
        color: ${(props) => props.theme.palette.primary.main};
      }

       @media ${(props) => props.theme.breakpoints.lg} {

        & .funds_container {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-bottom: 20px;
        }

        & .content {
          all: unset;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          background: blue;
          border-radius: 30px;
          overflow: hidden;
          max-width: 40%
        }

        & .button_funds {
          margin: 0px;
          width: 100%;
        }

        & .content-around {
          display: flex;
          width: 100%;
          padding-top: 10px;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;

          & .sub_title_restricted_cash {
            margin-bottom: 0px;
          }
          & .sub_title_cash {
            margin-bottom: 0px;
            max-width: 80%;
          }
          & .available_cash {
            max-width: 80%;
          }
          & .sub_containers {
            gap: 0px;
            flex-basis: 45%;
            text-align: center;
          }
        }
  
      }
    }
  }

  @media${(props) => props.theme.breakpoints.xl} {
    svg {
      margin-bottom: -10px;
      margin-right: 0px;
    }
    padding: 5px 14px;
  }

  @media ${(props) => props.theme.breakpoints.xs}, ${(props) => props.theme.breakpoints.lg} {
    svg {
      //margin-right: 20px;
    }
  }

  @media${(props) => props.theme.breakpoints.lg} {
    padding: 5px ${(props) => props.theme.spacers.pageX};
    //border: 1px solid cyan;

    &:hover, &.active {
      & > a {
        border-bottom: unset;
        color: ${(props) => props.theme.palette.primary.main};
      }
    }

    &.hide-lg {
      svg {
        display: inline-block;
      }
    }

    &.hide-sm {
      display: none;
    }

    &.submenu-container {
      padding: 0 20px !important;

      & > svg {
        display: none;
      }

      & .submenu {
        width: 100%;
        padding: 15px;
        display: block;

        @media ${(props) => props.theme.breakpoints.lg} {
          padding: 5px;
          padding-bottom: 20px;
        }

        & li {
          padding: 20px 0 !important;
          @media ${(props) => props.theme.breakpoints.lg} {
            padding: 0px !important;
          }
        }
      }
    }

    &.menucontent-container {
      padding: 0 20px !important;

      & > svg {
        display: none;
      }

      & .submenu {
        width: 100%;
        padding: 15px;        
        position: unset;
        display: block;
        
        @media ${(props) => props.theme.breakpoints.lg} {
          padding: 0px;
        }

        & li {
          padding: 20px 0 !important;
        }
      }
    }

    & a {
      text-transform: capitalize;
    }
  }
  
`;